import Box from "@material-ui/core/esm/Box";
import Tooltip from "@material-ui/core/esm/Tooltip";
import WarningRounded from "@material-ui/icons/esm/WarningRounded";
import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { OperationType } from 'api';
import { Title, Info } from 'components/Text';
import { getLongDateTime } from 'utils/date/dateTimeFormatter';
import useStyles from './LocalAgreementStyle';
export default function LocalAgreementItem({
  actorName,
  transactionCurrency,
  transactionExternalMomentOfCreation,
  transactionObeNumber,
  transactionOperationType,
  transactionTotalPrice,
  transactionDescription,
  isActive
}) {
  const {
    t
  } = useTranslation();
  const {
    warningIcon
  } = useStyles();
  const isMoreThanYearOld = dayjs() > dayjs(transactionExternalMomentOfCreation).add(1, 'year');
  const showWarning = isActive && isMoreThanYearOld;
  return /*#__PURE__*/React.createElement(Box, {
    mb: 3,
    mt: 3
  }, /*#__PURE__*/React.createElement(Title, {
    isBold: true,
    hasNoSpacing: true
  }, actorName, showWarning && /*#__PURE__*/React.createElement(Tooltip, {
    title: /*#__PURE__*/React.createElement(Info, null, t('local_agreement.more_than_one_year')),
    placement: "right-end"
  }, /*#__PURE__*/React.createElement(WarningRounded, {
    className: warningIcon
  }))), /*#__PURE__*/React.createElement(Info, null, `${t('local_agreement.timestamp')}: ${getLongDateTime(transactionExternalMomentOfCreation)}`), /*#__PURE__*/React.createElement(Info, null, `${t('local_agreement.obe')}: ${transactionObeNumber}`), /*#__PURE__*/React.createElement(Info, null, `${t('local_agreement.amount')}: ${transactionTotalPrice?.toFixed(2)} ${transactionCurrency}`, transactionOperationType === OperationType.Debit && ` (${t('local_agreement.credit')})`), /*#__PURE__*/React.createElement(Info, null, `${t('local_agreement.description')}: ${transactionDescription}`));
}